import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';
import {
  BaseControl,
  Textbox,
} from '@app/shared';


@Injectable()
export class ViewFormFormService {

  constructor() { }

  /**
   * Retorna el formulario de configuracion de revisiones
   *
   * @param {string} value
   * @returns {BaseControl<any>[]}
   * @memberof ViewFormFormService
   */
  getFormConfigRevisions(value: string): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'txtAliasCondiction',
        label: 'Alias de la condición que aplica para las revisiones:',
        value: value ? value : '',
        describe: 'Nota: este alias se utiliza como referencia para referenciar la condición ' +
                  'que aplica para las revisiones.',
        order: 1,
        placeholder: 'Alias del control',
        validations: {
          validators: [Validators.pattern('^[a-zA-Z_]*$')],
          messages: {pattern: 'Caracteres invalidos: solo letras y guiones bajos'}
        }
      }),
    ];
    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/view-form/shared/view-form.form.service.ts